export const SET_CONTRACTS = 'SET_CONTRACTS'
export const REMOVE_CONTRACTS = 'REMOVE_CONTRACTS'
export const RESET_CURRENT_HPOOL_TOKEN_CONTRACT = 'RESET_CURRENT_HPOOL_TOKEN_CONTRACT'
export const SET_CURRENT_HPOOL_TOKEN_CONTRACT = 'SET_CURRENT_HPOOL_TOKEN_CONTRACT'
